module.exports = __webpack_public_path__ + "static/media/stock market bnw.477be915.jpg";